import findIndex from 'lodash/findIndex';
export const assignHotKey = (field, index, array) => {
    if (field.removeLabel) {
        return 0;
    }
    else if (findIndex(array, (field) => field.removeLabel || false) > -1 &&
        index + 1 < 21) {
        return index % 10;
    }
    else if (index + 1 < 20) {
        return (index + 1) % 10;
    }
    else {
        return null;
    }
};
/**
 * Takes the pixel coordinate (that is associated with pageSize) and converts it to it's equivalent for canvasHeigth or canvasWidth
 * @param pixelCoordinate - top, bottom, left or right pixel value
 * @param pageDimension - pageSize.height or pageSize.width - the height or width of the document in pixels
 * @param canvasDimension - canvasHeight or canvasWidth - the height or width value of the canvas
 * @returns - coordinate for top, bottom, left or right in canvas height or width
 */
export const pageSizePixelToCanvasCoordinate = (pixelCoordinate, pageDimension, canvasDimension) => {
    return (pixelCoordinate / pageDimension) * canvasDimension;
};
//# sourceMappingURL=labeling.js.map